(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./packages/utilities/src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./packages/utilities/src/Digitransit.ts":
/*!***********************************************!*\
  !*** ./packages/utilities/src/Digitransit.ts ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToDigitransitStop = exports.convertToEpiserverFavouritePlace = exports.convertToDigitransitFavouritePlace = exports.generateDirectionsUrl = void 0;
var generateDirectionsUrl = function (item, journeyPlannerUrl, origin, lang) {
    var title = item.title, city = item.city, latitude = item.latitude, longitude = item.longitude;
    var parameter = "" + title + (city && ", " + city) + "::" + latitude + "," + longitude;
    return journeyPlannerUrl + "/" + lang + "/reitti/" + origin + "/" + encodeURIComponent(parameter);
};
exports.generateDirectionsUrl = generateDirectionsUrl;
var convertToDigitransitFavouritePlace = function (favouritePlace) {
    return {
        favouriteId: favouritePlace === null || favouritePlace === void 0 ? void 0 : favouritePlace.id,
        gid: favouritePlace === null || favouritePlace === void 0 ? void 0 : favouritePlace.gid,
        name: favouritePlace === null || favouritePlace === void 0 ? void 0 : favouritePlace.name,
        address: favouritePlace === null || favouritePlace === void 0 ? void 0 : favouritePlace.address,
        lat: favouritePlace === null || favouritePlace === void 0 ? void 0 : favouritePlace.latitude,
        lon: favouritePlace === null || favouritePlace === void 0 ? void 0 : favouritePlace.longitude,
        selectedIconId: favouritePlace === null || favouritePlace === void 0 ? void 0 : favouritePlace.icon,
        type: undefined,
        lastUpdate: undefined
    };
};
exports.convertToDigitransitFavouritePlace = convertToDigitransitFavouritePlace;
var convertToEpiserverFavouritePlace = function (favouritePlace) {
    return {
        id: favouritePlace === null || favouritePlace === void 0 ? void 0 : favouritePlace.favouriteId,
        name: favouritePlace === null || favouritePlace === void 0 ? void 0 : favouritePlace.name,
        icon: favouritePlace === null || favouritePlace === void 0 ? void 0 : favouritePlace.selectedIconId,
        gid: favouritePlace === null || favouritePlace === void 0 ? void 0 : favouritePlace.gid,
        address: favouritePlace === null || favouritePlace === void 0 ? void 0 : favouritePlace.address,
        postalcode: undefined,
        municipality: undefined,
        latitude: favouritePlace.lat,
        longitude: favouritePlace.lon,
        sortOrder: undefined
    };
};
exports.convertToEpiserverFavouritePlace = convertToEpiserverFavouritePlace;
var convertToDigitransitStop = function (favouriteStop) {
    return {
        favouriteId: undefined,
        type: 'stop',
        gtfsId: favouriteStop === null || favouriteStop === void 0 ? void 0 : favouriteStop.gtfsId,
        address: undefined,
        code: favouriteStop === null || favouriteStop === void 0 ? void 0 : favouriteStop.code,
        lat: undefined,
        lon: undefined,
        lastUpdated: 1
    };
};
exports.convertToDigitransitStop = convertToDigitransitStop;


/***/ }),

/***/ "./packages/utilities/src/Email.ts":
/*!*****************************************!*\
  !*** ./packages/utilities/src/Email.ts ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidEmail = void 0;
var emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
var isValidEmail = function (email) {
    return emailRegex.test(email);
};
exports.isValidEmail = isValidEmail;


/***/ }),

/***/ "./packages/utilities/src/Icon.ts":
/*!****************************************!*\
  !*** ./packages/utilities/src/Icon.ts ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconStyle = exports.getIcon = exports.getIconName = void 0;
var icons_1 = __importDefault(__webpack_require__(/*! @hsl-fi/icons */ "@hsl-fi/icons"));
var icon_config_1 = __webpack_require__(/*! @hsl-fi/icon-config */ "@hsl-fi/icon-config");
var Text_1 = __webpack_require__(/*! ./Text */ "./packages/utilities/src/Text.ts");
var getIconName = function (iconName) {
    if (!iconName) {
        return iconName;
    }
    var camelCaseName = (0, Text_1.snakeToCamel)(iconName);
    return (0, Text_1.capitalize)(camelCaseName);
};
exports.getIconName = getIconName;
var getIcon = function (icon) {
    if (!icon) {
        return null;
    }
    var iconName = (0, exports.getIconName)("" + icon), iconComponent = icons_1.default["" + iconName];
    return iconComponent ? iconComponent : null;
};
exports.getIcon = getIcon;
var getIconStyle = function (icon) {
    if (!icon) {
        return null;
    }
    var relativeSize = icon_config_1.relativeSizes[icon];
    if (!relativeSize) {
        return null;
    }
    return {
        transform: "scale(" + relativeSize + ")"
    };
};
exports.getIconStyle = getIconStyle;


/***/ }),

/***/ "./packages/utilities/src/Image.ts":
/*!*****************************************!*\
  !*** ./packages/utilities/src/Image.ts ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.addImagePreset = void 0;
var content_delivery_api_types_1 = __webpack_require__(/*! @hsl-fi/content-delivery-api-types */ "@hsl-fi/content-delivery-api-types");
var addImagePreset = function (imageUrl, preset) {
    if (preset === void 0) { preset = content_delivery_api_types_1.ImagePreset.DEFAULT; }
    if (!imageUrl || imageUrl === null) {
        return null;
    }
    imageUrl.includes('?') ? (imageUrl += '&') : (imageUrl += '?');
    return (imageUrl += "preset=" + preset);
};
exports.addImagePreset = addImagePreset;


/***/ }),

/***/ "./packages/utilities/src/Phone.ts":
/*!*****************************************!*\
  !*** ./packages/utilities/src/Phone.ts ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidPhoneNumber = void 0;
var phoneRegex = new RegExp(/((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/);
var isValidPhoneNumber = function (number) {
    return phoneRegex.test(number);
};
exports.isValidPhoneNumber = isValidPhoneNumber;


/***/ }),

/***/ "./packages/utilities/src/Property.ts":
/*!********************************************!*\
  !*** ./packages/utilities/src/Property.ts ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.classList = void 0;
var classList = function () {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(function (item) { return !!item; }).join(' ');
};
exports.classList = classList;


/***/ }),

/***/ "./packages/utilities/src/Scroll.ts":
/*!******************************************!*\
  !*** ./packages/utilities/src/Scroll.ts ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.animateScrollTo = exports.animateScrollDown = exports.animateScrollUp = exports.smoothScrollTo = exports.smoothScrollToFirstInvalidField = exports.ScrollSpeed = exports.smoothScrollToTop = void 0;
var smoothScrollToTop = function () {
    return new Promise(function (resolve) {
        var scrollFunction = function () {
            var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
            if (currentScroll === 0) {
                return resolve(void 0);
            }
            if (currentScroll > 0) {
                window.requestAnimationFrame(scrollFunction);
                window.scrollTo(0, currentScroll - currentScroll / 3);
            }
        };
        scrollFunction();
    });
};
exports.smoothScrollToTop = smoothScrollToTop;
var ScrollSpeed;
(function (ScrollSpeed) {
    ScrollSpeed["FAST"] = "FAST";
    ScrollSpeed["MEDIUM"] = "MEDIUM";
    ScrollSpeed["SLOW"] = "SLOW";
})(ScrollSpeed = exports.ScrollSpeed || (exports.ScrollSpeed = {}));
var speeds = (_a = {},
    _a[ScrollSpeed.FAST] = 100,
    _a[ScrollSpeed.MEDIUM] = 50,
    _a[ScrollSpeed.SLOW] = 20,
    _a);
var smoothScrollToFirstInvalidField = function (_a) {
    var speed = _a.speed, _b = _a.offset, offset = _b === void 0 ? 0 : _b;
    return __awaiter(void 0, void 0, void 0, function () {
        var firstInvalidField, scrollPosition, diff, scrolledToInvalidField;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    firstInvalidField = document.querySelectorAll('[aria-invalid="true"]')[0];
                    //  return if can't find a focusable invalid field
                    if (!firstInvalidField ||
                        typeof firstInvalidField.focus !== 'function' ||
                        typeof firstInvalidField.getBoundingClientRect !== 'function') {
                        return [2 /*return*/];
                    }
                    scrollPosition = firstInvalidField.getBoundingClientRect().top;
                    diff = Math.abs(Math.abs(scrollPosition) - Math.abs(offset));
                    if (diff < 2 || scrollPosition >= offset) {
                        firstInvalidField.focus();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, new Promise(function (resolve) {
                            var scrollFunction = function () {
                                var currentScroll = firstInvalidField.getBoundingClientRect().top;
                                if (currentScroll === 0) {
                                    resolve(true);
                                }
                                else if (currentScroll < 0) {
                                    var nextScrollStep = currentScroll + speeds[speed];
                                    if (nextScrollStep > 0) {
                                        var revisedScrollStep = speeds[speed] - nextScrollStep;
                                        window.scrollBy(0, -revisedScrollStep);
                                        return resolve(true);
                                    }
                                    window.requestAnimationFrame(scrollFunction);
                                    window.scrollBy(0, -speeds[speed]);
                                }
                                else {
                                    return resolve(false);
                                }
                            };
                            scrollFunction();
                        })];
                case 1:
                    scrolledToInvalidField = _c.sent();
                    if (scrolledToInvalidField) {
                        offset && window.scrollBy(0, offset);
                        firstInvalidField.focus();
                    }
                    else {
                        //  Unable to scroll to invalid field.  Focus on invalid field
                        firstInvalidField.focus();
                    }
                    return [2 /*return*/];
            }
        });
    });
};
exports.smoothScrollToFirstInvalidField = smoothScrollToFirstInvalidField;
var smoothScrollTo = function (ref, callBack, speed, offset) {
    if (offset === void 0) { offset = 0; }
    return __awaiter(void 0, void 0, void 0, function () {
        var scrollPosition, diff, scrolledToRef;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    scrollPosition = ref.current.getBoundingClientRect().top;
                    diff = Math.abs(Math.abs(scrollPosition) - Math.abs(offset));
                    if (diff < 2 || scrollPosition >= offset) {
                        return [2 /*return*/];
                    }
                    callBack(true);
                    return [4 /*yield*/, new Promise(function (resolve) {
                            var scrollFunction = function () {
                                var currentScroll = ref.current.getBoundingClientRect().top;
                                if (currentScroll === 0) {
                                    resolve(true);
                                }
                                else if (currentScroll < 0) {
                                    var nextScrollStep = currentScroll + speeds[speed];
                                    if (nextScrollStep > 0) {
                                        var revisedScrollStep = speeds[speed] - nextScrollStep;
                                        window.scrollBy(0, -revisedScrollStep);
                                        return resolve(true);
                                    }
                                    window.requestAnimationFrame(scrollFunction);
                                    window.scrollBy(0, -speeds[speed]);
                                }
                                else {
                                    return resolve(false);
                                }
                            };
                            scrollFunction();
                        })];
                case 1:
                    scrolledToRef = _a.sent();
                    if (scrolledToRef) {
                        offset && window.scrollBy(0, offset);
                    }
                    else {
                        //  Unable to scroll to ref.  Go to top of page
                        (0, exports.smoothScrollToTop)();
                    }
                    callBack(false);
                    return [2 /*return*/];
            }
        });
    });
};
exports.smoothScrollTo = smoothScrollTo;
var getSpeedWithEasing = function (currentOffset, speed) {
    var isNegative = currentOffset < 0, offset = isNegative ? currentOffset * -1 : currentOffset;
    var speedWithEasing = speed;
    if (offset >= 300 && offset < 500) {
        speedWithEasing = speed * 0.7;
    }
    if (offset >= 100 && offset < 300) {
        speedWithEasing = speed * 0.45;
    }
    if (offset >= 50 && offset < 100) {
        speedWithEasing = speed * 0.3;
    }
    if (offset >= 20 && offset < 50) {
        speedWithEasing = speed * 0.15;
    }
    if (offset > 0 && offset < 20) {
        speedWithEasing = speed * 0.1;
    }
    return isNegative ? speedWithEasing / -1 : speedWithEasing;
};
var animateScrollUp = function (_a) {
    var ref = _a.ref, speed = _a.speed, _b = _a.offset, offset = _b === void 0 ? 0 : _b, callback = _a.callback;
    return __awaiter(void 0, void 0, void 0, function () {
        var scrolledToRef;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (callback) {
                        callback(true);
                    }
                    return [4 /*yield*/, new Promise(function (resolve) {
                            var scrollFunction = function () {
                                var currentScroll = ref.current.getBoundingClientRect().top, speedWithEasing = getSpeedWithEasing(currentScroll, speed);
                                if (currentScroll === 0) {
                                    resolve(true);
                                }
                                else if (currentScroll < 0) {
                                    var nextScrollStep = currentScroll + speed;
                                    if (nextScrollStep >= offset) {
                                        window.scrollBy(0, -offset);
                                        return resolve(true);
                                    }
                                    window.requestAnimationFrame(scrollFunction);
                                    window.scrollBy(0, speedWithEasing);
                                }
                            };
                            scrollFunction();
                        })];
                case 1:
                    scrolledToRef = _c.sent();
                    if (scrolledToRef) {
                        offset && window.scrollBy(0, offset);
                    }
                    else {
                        //  Unable to scroll to ref.  Go to top of page
                        (0, exports.smoothScrollToTop)();
                    }
                    if (callback) {
                        callback(false);
                    }
                    return [2 /*return*/];
            }
        });
    });
};
exports.animateScrollUp = animateScrollUp;
var animateScrollDown = function (_a) {
    var ref = _a.ref, speed = _a.speed, _b = _a.offset, offset = _b === void 0 ? 0 : _b, callback = _a.callback;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (callback) {
                        callback(true);
                    }
                    return [4 /*yield*/, new Promise(function (resolve) {
                            var previousScroll = 0;
                            var scrollFunction = function () {
                                var currentScroll = ref.current.getBoundingClientRect().top, speedWithEasing = getSpeedWithEasing(currentScroll, speed);
                                if (currentScroll === 0) {
                                    resolve(true);
                                }
                                else if (currentScroll > 0) {
                                    if (currentScroll === previousScroll) {
                                        // case 1: scroll cannot proceed further, meaning we've reached the end of the page
                                        // case 2: scroll is stuck in the same position for some other reason
                                        return resolve(true);
                                    }
                                    else {
                                        previousScroll = currentScroll;
                                        var nextScrollStep = currentScroll - speed;
                                        if (nextScrollStep <= offset) {
                                            window.scrollBy(0, offset);
                                            return resolve(true);
                                        }
                                        window.requestAnimationFrame(scrollFunction);
                                        window.scrollBy(0, +speedWithEasing);
                                    }
                                }
                                else {
                                    return resolve(false);
                                }
                            };
                            scrollFunction();
                        })];
                case 1:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    });
};
exports.animateScrollDown = animateScrollDown;
var animateScrollTo = function (_a) {
    var ref = _a.ref, speed = _a.speed, _b = _a.offset, offset = _b === void 0 ? 0 : _b, callback = _a.callback;
    return __awaiter(void 0, void 0, void 0, function () {
        var speeds, scrollPosition, scrollSpeed, scrollMethod;
        var _c;
        return __generator(this, function (_d) {
            speeds = (_c = {},
                _c[ScrollSpeed.FAST] = 100,
                _c[ScrollSpeed.MEDIUM] = 50,
                _c[ScrollSpeed.SLOW] = 20,
                _c);
            scrollPosition = ref.current.offsetTop, scrollSpeed = speeds[speed], scrollMethod = window.scrollY > scrollPosition ? exports.animateScrollUp : exports.animateScrollDown;
            scrollMethod({ ref: ref, speed: scrollSpeed, offset: offset, callback: callback });
            return [2 /*return*/];
        });
    });
};
exports.animateScrollTo = animateScrollTo;


/***/ }),

/***/ "./packages/utilities/src/Text.ts":
/*!****************************************!*\
  !*** ./packages/utilities/src/Text.ts ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.removeExtraWhitespacesFromStartAndMiddle = exports.removeExtraWhitespaces = exports.generateId = exports.capitalize = exports.stringToKebab = exports.sanitize = exports.snakeToCamel = void 0;
var snakeToCamel = function (str) {
    if (!str || str === null)
        return str;
    return str.replace(/([-_][a-z])/g, function (group) {
        return group.toUpperCase().replace('-', '').replace('_', '');
    });
};
exports.snakeToCamel = snakeToCamel;
var sanitize = function (str) {
    if (!str || str === null)
        return str;
    return str.replace(/([Ää])|([Åå])/g, 'a').replace(/([Öö])/g, 'o');
};
exports.sanitize = sanitize;
var stringToKebab = function (str) {
    var _a;
    if (!str || str === null)
        return str;
    return (_a = str
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) === null || _a === void 0 ? void 0 : _a.map(function (x) { return x.toLowerCase(); }).join('-');
};
exports.stringToKebab = stringToKebab;
var capitalize = function (str) {
    if (!str || str === null)
        return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
};
exports.capitalize = capitalize;
var generateId = function (str) { return (0, exports.stringToKebab)((0, exports.sanitize)(str)); };
exports.generateId = generateId;
var removeExtraWhitespaces = function (str) {
    if (!str || str === null)
        return str;
    return str.replace(/\s+/g, ' ').trim();
};
exports.removeExtraWhitespaces = removeExtraWhitespaces;
var removeExtraWhitespacesFromStartAndMiddle = function (str) {
    if (!str || str === null)
        return str;
    return str.replace(/\s+/g, ' ').trimStart();
};
exports.removeExtraWhitespacesFromStartAndMiddle = removeExtraWhitespacesFromStartAndMiddle;


/***/ }),

/***/ "./packages/utilities/src/Url.ts":
/*!***************************************!*\
  !*** ./packages/utilities/src/Url.ts ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrl = void 0;
var DEFAULT_PATHS = {
    search: {
        fi: '/haku',
        sv: '/sv/sok',
        en: '/en/search'
    },
    userSelections: {
        fi: '/omat-tiedot/omat-valinnat',
        sv: '/sv/mina-uppgifter/mina-val',
        en: '/en/my-information/my-options'
    }
};
var getUrl = function (_a) {
    var page = _a.page, lang = _a.lang, hslFiUrl = _a.hslFiUrl, urlOverride = _a.urlOverride;
    if (urlOverride)
        return urlOverride;
    var hslFiUrlStripped = hslFiUrl.endsWith('/')
        ? hslFiUrl.slice(0, -1)
        : hslFiUrl;
    var path = DEFAULT_PATHS[page][lang] || DEFAULT_PATHS[page]['fi'];
    return "" + hslFiUrlStripped + path;
};
exports.getUrl = getUrl;
exports.default = exports.getUrl;


/***/ }),

/***/ "./packages/utilities/src/index.ts":
/*!*****************************************!*\
  !*** ./packages/utilities/src/index.ts ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlUtilities = exports.PhoneUtilities = exports.EmailUtilities = exports.DigitransitUtilities = exports.ImageUtilities = exports.ScrollUtilities = exports.PropertyUtilities = exports.IconUtilities = exports.TextUtilities = void 0;
var TextUtilities = __importStar(__webpack_require__(/*! ./Text */ "./packages/utilities/src/Text.ts"));
exports.TextUtilities = TextUtilities;
var IconUtilities = __importStar(__webpack_require__(/*! ./Icon */ "./packages/utilities/src/Icon.ts"));
exports.IconUtilities = IconUtilities;
var PropertyUtilities = __importStar(__webpack_require__(/*! ./Property */ "./packages/utilities/src/Property.ts"));
exports.PropertyUtilities = PropertyUtilities;
var ScrollUtilities = __importStar(__webpack_require__(/*! ./Scroll */ "./packages/utilities/src/Scroll.ts"));
exports.ScrollUtilities = ScrollUtilities;
var ImageUtilities = __importStar(__webpack_require__(/*! ./Image */ "./packages/utilities/src/Image.ts"));
exports.ImageUtilities = ImageUtilities;
var DigitransitUtilities = __importStar(__webpack_require__(/*! ./Digitransit */ "./packages/utilities/src/Digitransit.ts"));
exports.DigitransitUtilities = DigitransitUtilities;
var EmailUtilities = __importStar(__webpack_require__(/*! ./Email */ "./packages/utilities/src/Email.ts"));
exports.EmailUtilities = EmailUtilities;
var PhoneUtilities = __importStar(__webpack_require__(/*! ./Phone */ "./packages/utilities/src/Phone.ts"));
exports.PhoneUtilities = PhoneUtilities;
var UrlUtilities = __importStar(__webpack_require__(/*! ./Url */ "./packages/utilities/src/Url.ts"));
exports.UrlUtilities = UrlUtilities;
__exportStar(__webpack_require__(/*! ./Icon */ "./packages/utilities/src/Icon.ts"), exports);
__exportStar(__webpack_require__(/*! ./Text */ "./packages/utilities/src/Text.ts"), exports);
__exportStar(__webpack_require__(/*! ./Property */ "./packages/utilities/src/Property.ts"), exports);
__exportStar(__webpack_require__(/*! ./Scroll */ "./packages/utilities/src/Scroll.ts"), exports);
__exportStar(__webpack_require__(/*! ./Image */ "./packages/utilities/src/Image.ts"), exports);
__exportStar(__webpack_require__(/*! ./Digitransit */ "./packages/utilities/src/Digitransit.ts"), exports);
__exportStar(__webpack_require__(/*! ./Email */ "./packages/utilities/src/Email.ts"), exports);
__exportStar(__webpack_require__(/*! ./Phone */ "./packages/utilities/src/Phone.ts"), exports);
__exportStar(__webpack_require__(/*! ./Url */ "./packages/utilities/src/Url.ts"), exports);


/***/ }),

/***/ "@hsl-fi/content-delivery-api-types":
/*!*****************************************************!*\
  !*** external "@hsl-fi/content-delivery-api-types" ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@hsl-fi/content-delivery-api-types");

/***/ }),

/***/ "@hsl-fi/icon-config":
/*!**************************************!*\
  !*** external "@hsl-fi/icon-config" ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@hsl-fi/icon-config");

/***/ }),

/***/ "@hsl-fi/icons":
/*!********************************!*\
  !*** external "@hsl-fi/icons" ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@hsl-fi/icons");

/***/ })

/******/ });
});
//# sourceMappingURL=index.js.map